import { FCX } from "@datassential/platform-ui-lib";
import { RawNorm, useProfileContext } from "@pages/Profile/ProfileContext";
import ContentHeader from "@components/ContentHeader";
import Title from "@components/Title";
import Tabs from "@components/Tabs";
import { ProfileDataResponseItem } from "@core/api/useProfileHeader";
import cn from "classnames";
import './SubHeader.scss';
import SelectAmong from "@vms/SelectAmong";
import SelectVersus from "@vms/SelectVersus";

type SubHeaderProps = {
	categoriesIds: ProfileDataResponseItem["categoriesIds"];
	name: ProfileDataResponseItem["name"];
}

const tabsData = [
	{ id: RawNorm.Raw, title: "Raw" },
	{ id: RawNorm.Norm, title: "Norms" },
];

const SubHeader: FCX<SubHeaderProps> = ({
	categoriesIds,
	name,
}) => {
	const {
		rawNorms,
		setRawNorms,
		categoryId,
		setCategoryId,
	} = useProfileContext();

	return (
		<ContentHeader
			className="ProfileSubHeader"
			testId="blockProfileSubHeader"
		>
			<Title
				className={cn(
					"appears-right",
					"del-2",
				)}
				testId="textProfileSubHeaderTitle"
			>
				{name?.toUpperCase() ?? ''}
			</Title>
			<div className="ProfileSubHeader__content">
				{rawNorms === RawNorm.Norm && (
					<SelectVersus
						value={categoryId}
						setValue={(value) => setCategoryId(value as number)}
						className={
							cn(
								"appears-left",
								"fast",
							)
						}
						categoriesIds={categoriesIds ?? []}
						testId="selectProfileSubHeaderVersus"
					/>
				)}
				<div 
					className={cn(
						"ProfileSubHeader__filters",
						"appears-left",
						"del-2",
					)}>
					<SelectAmong
						className="TrendHeader__select TrendHeaderSelect"
						label={<span data-testid="textProfileTrendRespondentType">AMONG:</span>}
						testId="selectProfileTrendAmong"
						useGroupsLimit
						useCoExclusions
					/>
					<Tabs
						data={tabsData}
						modifiers={["height-l"]}
						activeTabId={rawNorms}
						onItemClick={setRawNorms}
						testId="blockProfileSubHeaderRawNorms"
					/>
				</div>
			</div>
		</ContentHeader>
	);
};

export default SubHeader; 